/**
 * Generated by orval v8.23.0 🍺
 * Do not edit manually.
 * Arbi API
 * OpenAPI spec version: 1.0.0
 */

/**
 * Monthly point for estimated headcount from profile tenure overlap (YYYY-MM, count).
 */
export interface CompanyHeadcountPointSchema {
  date: string;
  count: number;
}
